module.exports = __webpack_public_path__ + "img/jzsgaq1.7109fde0.png";